<template>
  <div class="animated fadeIn">
    <ShipOrderDialog EntityType="Order">
      <div slot="header">
        <h2>Test</h2>
      </div>
      <div slot="details">
        <!-- <div>{{ mySelected.Title }}</div>
              <div>{{ mySelected.Email1 }}</div> -->
      </div>
      <span slot="entityType">Sponsor</span>
    </ShipOrderDialog>
    <b-row>
      <!-- <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i class="fa fa-times appendIcon clickIcon" @click="resetSearch"></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>-->
      <b-col lg="9">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          v-model="filterStatus"
          name="radiosBtn"
          @change.native="preprocessFilter"
        >
          <b-form-radio class="mx-0 longStandardizedRadioWidth" value="SUSA"
            >SUSA</b-form-radio
          >
          <b-form-radio class="mx-0 longStandardizedRadioWidth" value="LUSA"
            >LUSA</b-form-radio
          >
          <b-form-radio class="mx-0 longStandardizedRadioWidth" value="SCAN"
            >SCAN</b-form-radio
          >
          <b-form-radio class="mx-0 longStandardizedRadioWidth" value="HMCUSA"
            >HMC</b-form-radio
          >
          <b-form-radio class="mx-0 longStandardizedRadioWidth" value="all"
            >SHOW ALL</b-form-radio
          >
        </b-form-radio-group>
      </b-col>
      <b-col lg="3">
        <b-form-group>
          <CoolSelect
            v-model="myCurrentMonth"
            class="form-input dropdown-content"
            placeholder="Month"
            theme="bootstrap"
            tooltip="Months"
            :items="shipping.active_months"
            item-text="Description"
            item-value="ShippingMonthID"
            id="ShippingMonthID"
            @select="changeMonth()"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text>Month</b-input-group-text>
              </b-input-group-prepend>
            </template>
            <!-- <template slot="item" slot-scope="{ item }">
                    <div class="item">
                      <img :src="item.thumbnail" class="logo" />
                      <span class="item-name">{{ item.CommonName }}</span>
                    </div>
            </template>-->
          </CoolSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler2"
          :items="filteredOrders"
          :fields="fields"
          hover
          small
          fixed
          striped
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
          <template slot="bottom-row" slot-scope="data">
            <td>
              <span class="fa-narbar mybold">Totals</span>
            </td>
            <td></td>
            <td>
              <span class="fa-narbar mybold">{{ SUMS[0] }}</span>
            </td>
            <!-- <td>
              <span class="fa-narbar mybold">{{SUMS[1]}}</span>
            </td>-->
            <!-- <td>
              <span class="fa-narbar mybold">{{SUMS[2]}}</span>
            </td>
            <td>
              <span class="fa-narbar mybold">{{SUMS[3]}}</span>
            </td>
            <td>
              <span class="fa-narbar mybold">{{SUMS[4]}}</span>
            </td>-->
            <td>
              <span class="fa-narbar mybold">{{ SUMS[5] }}</span>
            </td>
            <td>
              <span class="fa-narbar mybold">{{ SUMS[6] }}</span>
            </td>
            <td>
              <span class="fa-narbar mybold">{{ SUMS[7] }}</span>
            </td>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
    <b-row class="primary-row divider-row">
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              class="divider-input"
              type="text"
              placeholder="Search"
              @keyup="searchWait"
              v-model.lazy="searchString"
            />

            <b-input-group-append>
              <b-input-group-text class="divider-input">
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <span class="divider-input pt-1"
              >There are {{ filteredRowCount() }} shipments that match this
              criteria
            </span>
            <i
              v-b-tooltip
              v-if="
                isSubSet &&
                  this.filteredRowCount() > 0 &&
                  this.downloadFileName == ''
              "
              title="Download"
              style="cursor: pointer;"
              class="cui-cloud-download icons font-xl d-block ml-2 mt-3"
              @click="downloadSubSet"
            />
            <span class="divider-input pt-1 pl-3">
              <a
                v-if="
                  isSubSet &&
                    this.filteredRowCount() > 0 &&
                    this.downloadFileName != ''
                "
                :href="downloadFileLink"
                target="_blank"
              >
                File Ready
              </a>
            </span>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredShippingOrders"
          :fields="fields2"
          hover
          small
          fixed
          striped
          caption
          select-mode="single"
          selectable
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage2"
          :per-page="perPage2"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNav2Visible">
          <b-pagination
            :per-page="perPage2"
            :total-rows="filteredShippingOrdersRowCount"
            v-model="currentPage2"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { CoolSelect } from "vue-cool-select";
import { mapState, mapActions, mapGetters } from "vuex";
import cTable from "@/views/base/Table.vue";
import ShipOrderDialog from "@/views/shipping/ShippingOrderModal.vue";

export default {
  name: "ShippingOrders",
  data: () => {
    return {
      fields: [
        {
          key: "CapGroup",
          label: "Group",
          sortable: true
        },
        {
          key: "OrderType",
          label: "Type",
          sortable: true
        },
        {
          key: "Quantity",
          label: "Received",
          sortable: true
        },
        // {
        //   key: "Kits",
        //   label: "Kits",
        //   sortable: true
        // },
        // {
        //   key: "ExtraCaps",
        //   label: "Caps",
        //   sortable: true
        // },
        // {
        //   key: "Notecards",
        //   label: "Notecards",
        //   sortable: true
        // },
        // {
        //   key: "Stickers",
        //   label: "Stickers",
        //   sortable: true
        // },
        // {
        //   key: "CompletedQuantity",
        //   label: "Completed",
        //   sortable: true
        // },
        {
          key: "CompletedQuantity",
          label: "Completed",
          sortable: true
        },
        {
          key: "CanceledQuantity",
          label: "Canceled",
          sortable: true
        },
        {
          key: "QuantityRemaining",
          label: "Remaining",
          sortable: true
        }
      ],
      fields2: [
        {
          key: "PONumber",
          label: "OrderID",
          sortable: true
        },
        {
          key: "CapGroup",
          label: "Group",
          sortable: true
        },
        {
          key: "FulfillmentType",
          label: "Type",
          sortable: true
        },
        {
          key: "ShipCompany",
          label: "Company",
          sortable: true
        },
        {
          key: "ShipName",
          label: "Name",
          sortable: true
        },
        {
          key: "ShipStatus",
          label: "Status",
          sortable: true
        }
      ],
      mySelected: {},
      mySelected2: {},
      currentPage: 1,
      perPage: 50,
      currentPage2: 1,
      perPage2: 50,
      filteredOrders: [],
      filteredShippingOrders: [],
      filterStatus: "all",
      searchString: "",
      SUMS: [0, 0, 0, 0, 0, 0, 0, 0],
      timer: null,
      isSubSet: false,
      myCurrentMonth: {},
      subSetGroup: "",
      subSetType: "",
      subSetFilter: "",
      downloadFileName: "",
      downloadFilePath: "https://api.icap-maker.com/Output/"
    };
  },
  props: {},
  components: {
    cTable,
    CoolSelect,
    ShipOrderDialog
  },
  created() {
    //alert(this.$store.state.shipping.active_month.ShippingMonthID);
    this.$store
      .dispatch(
        "shipping/get_subtotals",
        this.$store.state.shipping.active_month.ShippingMonthID
      )
      .then(() => {
        this.filterList();
      });
    this.$store
      .dispatch(
        "shipping/get_orders",
        this.$store.state.shipping.active_month.ShippingMonthID
      )
      .then(() => {
        this.filterList2();
      });

    this.$store.dispatch("shipping/shippingMonths").then(() => {
      //alert("before mycurrentmonth");
      this.myCurrentMonth = this.$store.state.shipping.active_months.find(
        month => month.IsCurrent === true
      );
      //alert("after mycurrentmonth");
      //this.$store.state.shipping.active_month;
      //this.viewMonth = this.currentShippingMonth;
      //alert(this.myCurrentMonth.ShippingMonthID);
    });

    //.then((this.filteredOrders = this.$store.state.order.one_time_orders));
  },
  mounted() {
    // this.$store
    //   .dispatch("order/getOTOrders")
    //   .then((this.filteredOrders = this.$store.state.order.one_time_orders));
  },
  computed: {
    ...mapGetters({
      totalRows: "shipping/SubTotalCount",
      totalRows2: "shipping/ShippingOrderCount"
    }),
    isNavVisible: function() {
      return this.totalRows > this.perPage;
    },
    isNav2Visible: function() {
      //return this.totalRows2 > this.perPage2;
      return this.filteredShippingOrdersRowCount > this.perPage2;
    },
    filteredShippingOrdersRowCount: function() {
      return this.filteredShippingOrders.length;
    },
    downloadFileLink: function() {
      return this.downloadFilePath + this.downloadFileName;
    },
    ...mapState(["shipping", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  methods: {
    async downloadSubSet() {
      var _op = {
        MonthID: this.myCurrentMonth,
        MailGroup: this.subSetGroup,
        MailType: this.subSetType,
        MailFilter: this.subSetFilter
      };
      this.$store
        .dispatch("shipping/createDownloadFile", _op)
        .then(response => {
          this.downloadFileName =
            response.data["ShippingInformationDownloadResult"];
          console.log(this.downloadFileName);
        });
    },
    myRowClickHandler2(record, index, evt) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      //alert(record.UserProfileID);
      //this.mySelected = record;
      //console.log(record);
      //console.log(index);
      //console.log(evt.srcElement.cellIndex);

      var _filter;
      switch (evt.srcElement.cellIndex) {
        case 3:
          _filter = "Complete";
          break;
        case 4:
          _filter = "Canceled";
          break;
        case 5:
          _filter = "Received";
          break;
        default:
          return;
      }
      var _group = record.CapGroup;
      var _type = record.OrderType;
      this.filterListParams(_group, _type, _filter);
    },
    filteredRowCount: function() {
      return this.filteredShippingOrders.length;
    },
    ResetTotals: function() {
      this.SUMS = [0, 0, 0, 0, 0, 0, 0, 0];
    },
    filterList: function() {
      this.ResetTotals();
      //alert(this.$store.state.order.one_time_orders.length);
      if (this.filterStatus === "all") {
        this.filteredOrders = this.$store.state.shipping.subtotals;
      } else {
        this.filteredOrders = this.$store.state.shipping.subtotals.filter(
          ord => ord.CapGroup === this.filterStatus
        );
      }
      //alert(this.SUMS[0]);
      for (var i = 0; i < this.filteredOrders.length; i++) {
        //alert(this.filteredOrders[i].Quantity);
        this.SUMS[0] = this.SUMS[0] + this.filteredOrders[i].Quantity;
        this.SUMS[1] = this.SUMS[1] + this.filteredOrders[i].Kits;
        this.SUMS[2] = this.SUMS[2] + this.filteredOrders[i].ExtraCaps;
        this.SUMS[3] = this.SUMS[3] + this.filteredOrders[i].Notecards;
        this.SUMS[4] = this.SUMS[4] + this.filteredOrders[i].Stickers;
        this.SUMS[5] = this.SUMS[5] + this.filteredOrders[i].CompletedQuantity;
        this.SUMS[6] = this.SUMS[6] + this.filteredOrders[i].CanceledQuantity;
        this.SUMS[7] = this.SUMS[7] + this.filteredOrders[i].QuantityRemaining;
      }
      this.filterList2();
      // this.filteredOrders = this.filteredOrders.filter(
      //   ord =>
      //     ord.OrderID.toLowerCase().indexOf(this.searchString.toLowerCase()) >
      //       -1 ||
      //     ord.CustomerID.toLowerCase().indexOf(
      //       this.searchString.toLowerCase()
      //     ) > -1
      // );
    },
    filterList2: function() {
      if (this.filterStatus === "all") {
        this.filteredShippingOrders = this.$store.state.shipping.shipping_orders;
      } else {
        this.filteredShippingOrders = this.$store.state.shipping.shipping_orders.filter(
          ord => ord.CapGroup === this.filterStatus
        );
      }
      this.filteredShippingOrders = this.filteredShippingOrders.filter(
        ord =>
          ord.FulfillmentType.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          ord.PONumber.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          ord.ShipName.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          ord.ShipCompany.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          ord.ShipStatus.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          ord.FulfillmentType.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    filterListParams: function(_group, _type, _filter) {
      this.isSubSet = true;
      this.downloadFileName = "";
      this.subSetGroup = _group;
      this.subSetType = _type;
      this.subSetFilter = _filter;
      this.filteredShippingOrders = this.$store.state.shipping.shipping_orders.filter(
        ord => ord.CapGroup === _group
      );

      this.filteredShippingOrders = this.filteredShippingOrders.filter(
        ord => ord.FulfillmentType === _type && ord.ShipStatus === _filter
      );
    },
    searchWait(event) {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.filterList2();
      }, 2000);
    },
    preprocessFilter: function(event) {
      this.filterList();
    },
    resetSearch: function() {
      this.searchString = "";
      this.isSubSet = false;
      this.downloadFileName = "";
      this.subSetFilter = "";
      this.subSetGroup = "";
      this.subSetType = "";
      this.filterList();
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store
        .dispatch("shipping/loadShippingOrderEdit", record.PONumber)
        .then(() => {
          //this.$router.push({ name: "ShippingOrder" });
          this.$bvModal.show("modal-shiporder");
        });
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    changeMonth() {
      this.resetSearch();
      this.ResetTotals();
      this.$store
        .dispatch("shipping/get_subtotals", this.myCurrentMonth)
        .then(() => {
          this.filterList();
        });
      this.$store
        .dispatch("shipping/get_orders", this.myCurrentMonth)
        .then(() => {
          this.filterList2();
        });
    }

    // totalRows() {
    //   if (this.filteredOrders) {
    //     return this.filteredOrders.length;
    //   } else {
    //     return this.$store.state.order.one_time_orders.length;
    //   }
    // }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
